import { connect } from "react-redux";
import Valet from './valet'
import { bindActionCreators } from "redux";
import { createValet } from "services/redux/Valet/AddValet/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { valetList } from "services/redux/Valet/Supervisor/action";
const mapStateToProps = (state) => ({
    valetList : state.CreateSupervisor.valetList,
    valetRes : state.CreateValet.valetRes,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createValet,
        valetList,
        documentUploadUrlPublic,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Valet);